// Alertas de voz por estación (Web Speech API). Config local por dispositivo/estación.
const KEY = "pos_voice_cfg";

export function getVoiceCfg() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    if (c) return { enabled: c.enabled !== false, volume: typeof c.volume === "number" ? c.volume : 1 };
  } catch (e) { /* ignore */ }
  return { enabled: true, volume: 1 };
}

export function setVoiceCfg(cfg) {
  localStorage.setItem(KEY, JSON.stringify(cfg));
  window.dispatchEvent(new Event("voice-cfg-updated"));
}

export const voiceSupported = typeof window !== "undefined" && "speechSynthesis" in window;

// Impresión de comandas por estación. Activo solo en el equipo con impresora (la caja).
const PRINT_KEY = "pos_print_comandas";
export function getPrintComandas() {
  const v = localStorage.getItem(PRINT_KEY);
  return v === null ? true : v === "1";
}
export function setPrintComandas(on) {
  localStorage.setItem(PRINT_KEY, on ? "1" : "0");
  window.dispatchEvent(new Event("print-cfg-updated"));
}

let esVoice = null;
function pickVoice() {
  if (!voiceSupported) return null;
  const voices = window.speechSynthesis.getVoices() || [];
  esVoice =
    voices.find((v) => /es[-_]?(MX|419|US)/i.test(v.lang)) ||
    voices.find((v) => (v.lang || "").toLowerCase().startsWith("es")) ||
    null;
  return esVoice;
}
if (voiceSupported) {
  pickVoice();
  try { window.speechSynthesis.onvoiceschanged = pickVoice; } catch (e) { /* ignore */ }
}

export function speak(text) {
  if (!voiceSupported || !text) return;
  const cfg = getVoiceCfg();
  if (!cfg.enabled) return;
  try {
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "es-MX";
    u.rate = 1;
    u.pitch = 1;
    u.volume = Math.max(0, Math.min(1, cfg.volume));
    const v = esVoice || pickVoice();
    if (v) u.voice = v;
    window.speechSynthesis.speak(u);
  } catch (e) { /* ignore */ }
}

export function speakTest() {
  if (!voiceSupported) return;
  try { window.speechSynthesis.cancel(); } catch (e) { /* ignore */ }
  speak("Alerta de voz activada. Mesa 5, pedido nuevo.");
}
